const hook = {
    missing_events: 'باید حداقل یک رویداد ارائه دهید.',
    send_test_payload_failed: 'ارسال بار آزمایشی ناموفق بود: {{message}}',
    endpoint_responded_with_error: 'مقصد با خطا پاسخ داد.',
};
export default Object.freeze(hook);
